// extracted by mini-css-extract-plugin
export default {"container":"PrintableLabelLink_container__QBEWH","link":"PrintableLabelLink_link__ppf6H"};